import { initProductBox } from "../components/product-box";

export default () => {
  const productList = $(".type-category");

  if (productList.length > 0) {
    $("#filters").addClass("visible");

    $(document).ajaxComplete(function () {
      initProductBox();
      moveDescription();
      initFilterDropdown();
      initLoadMoreProducts();
    });

    const loadMore = document.querySelector(".load-products");
    loadMore.addEventListener("click", () => {
      setTimeout(() => {
        initProductBox();
      }, 1000);
    });

    moveDescription();
    initFilterDropdown();
    initLoadMoreProducts();
  }
};

function moveDescription() {
  $(".category-perex").insertAfter(".category-title");
}

function initFilterDropdown() {
  const dropdown = $("#category-filter-hover .filter-section");
  $("label[for='stock']").html("Skladem");

  $(document).mouseup((e) => {
    if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
      dropdown.removeClass("is-open");
    }
  });

  $("#category-filter-hover .filter-section h4").click(function () {
    $(".filter-section").removeClass("is-open");
    $(this).parent().toggleClass("is-open");
  });
}

function initLoadMoreProducts() {
  $(".load-products").text("Zobrazit další produkty");
}
